// extracted by mini-css-extract-plugin
export default {"darkOnly":"BriefThumb_darkOnly__LcbUZ","lightOnly":"BriefThumb_lightOnly__ieBMY"};